import React from "react";

export default class CommonFunction {
    static delay = (ms:number) => new Promise((res:any) => setTimeout(res, ms));
}